import { render, staticRenderFns } from "./ConfigDataMartsDataMarts.vue?vue&type=template&id=44560514&scoped=true&"
import script from "./ConfigDataMartsDataMarts.vue?vue&type=script&lang=js&"
export * from "./ConfigDataMartsDataMarts.vue?vue&type=script&lang=js&"
import style0 from "./ConfigDataMartsDataMarts.vue?vue&type=style&index=0&id=44560514&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44560514",
  null
  
)

export default component.exports